// src/data/blogPosts.js

const blogPosts = [
  {
    id: "what-is-hookora",
    title: "What Is Hookora?",
    description:
      "Learn what Hookora is, how it works, and why Hookora helps creators generate hooks, titles, captions, hashtags, scripts, descriptions, and thumbnail text faster.",
    slug: "/blog/what-is-hookora",
    image: "/og/ai-tools-for-creators.jpg",
    badge: "Hookora",
    category: "ai-tools",
    categoryLabel: "AI Creator Tools",
    tags: [
      "hooks",
      "captions",
      "creator-workflow",
      "ai-tools"
    ],
    keywords: [
      "hookora",
      "creator workflow",
      "AI tools",
      "captions",
      "hooks"
    ],
    featured: true,
    publishedTime: "2026-07-04",
    updatedTime: "2026-07-04",
    readTime: "6 min read"
  },

  {
    id: "hookora-for-nigerian-creators",
    title: "Hookora for Nigerian Creators",
    description:
      "Learn how Hookora helps Nigerian creators write stronger hooks, titles, captions, scripts, and content packaging faster with a smoother workflow.",
    slug:
      "/blog/hookora-for-nigerian-creators",
    image: "/og/ai-tools-for-creators.jpg",
    badge: "Hookora",
    category:
      "creator-workflow",
    categoryLabel:
      "Creator Workflow",
    tags: [
      "nigerian-creators",
      "creator-workflow",
      "hooks",
      "captions"
    ],
    keywords: [
      "Nigerian creators",
      "workflow",
      "hooks",
      "captions"
    ],
    featured: true,
    publishedTime: "2026-07-04",
    updatedTime: "2026-07-04",
    readTime: "7 min read"
  },

  {
    id:
      "how-hookora-helps-creators-write-hooks-faster",
    title:
      "How Hookora Helps Creators Write Hooks Faster",
    description:
      "Learn how Hookora helps creators write hooks faster with clearer angles, stronger first lines, and a smoother content workflow.",
    slug:
      "/blog/how-hookora-helps-creators-write-hooks-faster",
    image: "/og/50-viral-hooks.jpg",
    badge: "Hookora",
    category: "hooks",
    categoryLabel:
      "Viral Hooks",
    tags: [
      "hooks",
      "viral-hooks",
      "short-form",
      "retention"
    ],
    keywords: [
      "hooks",
      "viral hooks",
      "hook writing",
      "short-form"
    ],
    featured: true,
    publishedTime: "2026-07-04",
    updatedTime: "2026-07-04",
    readTime: "8 min read"
  },

  {
    id:
      "ai-tools-for-nigerian-creators",
    title:
      "AI Tools for Nigerian Creators",
    description:
      "Discover AI tools for Nigerian creators who want faster content workflow, stronger hooks, better captions, sharper titles, and more consistent output.",
    slug:
      "/blog/ai-tools-for-nigerian-creators",
    image:
      "/og/ai-tools-for-creators.jpg",
    badge:
      "AI Creator Tools",
    category: "ai-tools",
    categoryLabel:
      "AI Creator Tools",
    tags: [
      "ai-tools",
      "creator-tools",
      "workflow"
    ],
    keywords: [
      "AI tools",
      "creator tools",
      "Nigerian creators"
    ],
    featured: true,
    publishedTime: "2026-07-04",
    updatedTime: "2026-07-04",
    readTime: "8 min read"
  },

  {
    id:
      "best-hook-generator-for-nigerian-creators",
    title:
      "Best Hook Generator for Nigerian Creators",
    description:
      "See how Nigerian creators can use Hookora to create stronger hooks, opening lines, and first impressions for videos and social content.",
    slug:
      "/blog/best-hook-generator-for-nigerian-creators",
    image:
      "/og/50-viral-hooks.jpg",
    badge: "Hooks",
    category: "hooks",
    categoryLabel:
      "Viral Hooks",
    tags: [
      "hooks",
      "tiktok",
      "reels",
      "shorts"
    ],
    keywords: [
      "hook generator",
      "TikTok hooks",
      "Reels hooks"
    ],
    featured: true,
    publishedTime: "2026-07-04",
    updatedTime: "2026-07-04",
    readTime: "8 min read"
  },

  {
    id:
      "content-tools-for-creators-in-nigeria",
    title:
      "Content Tools for Creators in Nigeria",
    description:
      "Explore content tools for creators in Nigeria who want a clearer workflow for hooks, captions, titles, scripts, and content packaging.",
    slug:
      "/blog/content-tools-for-creators-in-nigeria",
    image:
      "/og/ai-tools-for-creators.jpg",
    badge:
      "Content Tools",
    category:
      "creator-workflow",
    categoryLabel:
      "Creator Workflow",
    tags: [
      "content-tools",
      "workflow",
      "content-packaging"
    ],
    keywords: [
      "content tools",
      "creator workflow",
      "content packaging"
    ],
    featured: false,
    publishedTime: "2026-07-04",
    updatedTime: "2026-07-04",
    readTime: "8 min read"
  },

  {
    id:
      "best-caption-generator-for-nigerian-creators",
    title:
      "Best Caption Generator for Nigerian Creators",
    description:
      "Learn how Hookora helps Nigerian creators write clearer and faster captions for Instagram, TikTok, Shorts, and broader creator workflow.",
    slug:
      "/blog/best-caption-generator-for-nigerian-creators",
    image:
      "/og/creators-formulas.jpg",
    badge: "Captions",
    category:
      "creator-workflow",
    categoryLabel:
      "Creator Workflow",
    tags: [
      "captions",
      "instagram",
      "tiktok",
      "shorts"
    ],
    keywords: [
      "captions",
      "Instagram captions",
      "TikTok captions"
    ],
    featured: false,
    publishedTime: "2026-07-04",
    updatedTime: "2026-07-04",
    readTime: "7 min read"
  },

  {
    id:
      "how-nigerian-creators-can-write-better-hooks",
    title:
      "How Nigerian Creators Can Write Better Hooks",
    description:
      "Learn practical ways Nigerian creators can write better hooks for Reels, Shorts, TikTok, and social content with stronger first lines.",
    slug:
      "/blog/how-nigerian-creators-can-write-better-hooks",
    image:
      "/og/50-viral-hooks.jpg",
    badge:
      "Hook Writing",
    category: "hooks",
    categoryLabel:
      "Viral Hooks",
    tags: [
      "hooks",
      "tiktok",
      "reels",
      "retention"
    ],
    keywords: [
      "hook writing",
      "TikTok hooks",
      "Reels hooks"
    ],
    featured: false,
    publishedTime: "2026-07-04",
    updatedTime: "2026-07-04",
    readTime: "7 min read"
  },

  {
    id:
      "50-viral-hook-examples",
    title:
      "50 Viral Hook Examples",
    description:
      "Explore 50 viral hook examples creators use to increase retention, improve watch time, and capture attention across TikTok, Reels, and Shorts.",
    slug:
      "/blog/50-viral-hook-examples",
    image:
      "/og/50-viral-hooks.jpg",
    badge:
      "Viral Hooks",
    category: "hooks",
    categoryLabel:
      "Viral Hooks",
    tags: [
      "viral-hooks",
      "tiktok",
      "shorts",
      "reels"
    ],
    keywords: [
      "viral hooks",
      "TikTok",
      "Shorts",
      "Reels"
    ],
    featured: true,
    publishedTime: "2026-07-04",
    updatedTime: "2026-07-04",
    readTime: "8 min read"
  },

  {
    id:
      "how-to-write-viral-hooks",
    title:
      "How to Write Viral Hooks",
    description:
      "Learn how creators write stronger viral hooks that improve retention, increase watch time, and capture attention across TikTok, Reels, and Shorts.",
    slug:
      "/blog/how-to-write-viral-hooks",
    image:
      "/og/creators-formulas.jpg",
    badge:
      "Hook Writing",
    category: "hooks",
    categoryLabel:
      "Viral Hooks",
    tags: [
      "hooks",
      "watch-time",
      "retention"
    ],
    keywords: [
      "viral hooks",
      "watch time",
      "retention"
    ],
    featured: false,
    publishedTime: "2026-07-04",
    updatedTime: "2026-07-04",
    readTime: "7 min read"
  },

  {
    id:
      "best-hook-formulas-for-tiktok",
    title:
      "Best Hook Formulas for TikTok",
    description:
      "Discover proven hook formulas creators use on TikTok, Reels, and Shorts to improve retention, increase watch time, and capture attention faster.",
    slug:
      "/blog/best-hook-formulas-for-tiktok",
    image:
      "/og/creators-formulas.jpg",
    badge:
      "TikTok Hooks",
    category: "tiktok",
    categoryLabel:
      "TikTok Hooks",
    tags: [
      "tiktok",
      "hooks",
      "shorts",
      "reels"
    ],
    keywords: [
      "TikTok",
      "hooks",
      "Shorts",
      "Reels"
    ],
    featured: true,
    publishedTime: "2026-07-04",
    updatedTime: "2026-07-04",
    readTime: "9 min read"
  },

  {
    id:
      "best-retention-strategies-for-reels",
    title:
      "Best Retention Strategies for Reels",
    description:
      "Discover practical retention strategies creators use to improve watch time, engagement, and performance on Instagram Reels.",
    slug:
      "/blog/best-retention-strategies-for-reels",
    image:
      "/og/watch-time.jpg",
    badge:
      "Retention",
    category:
      "retention",
    categoryLabel:
      "Retention Strategies",
    tags: [
      "retention",
      "reels",
      "watch-time"
    ],
    keywords: [
      "retention",
      "Reels",
      "watch time"
    ],
    featured: false,
    publishedTime: "2026-07-04",
    updatedTime: "2026-07-04",
    readTime: "8 min read"
  },

  {
    id:
      "how-creators-increase-watch-time",
    title:
      "How Creators Increase Watch Time",
    description:
      "Learn how creators improve watch time using stronger hooks, retention strategies, pacing, and storytelling across TikTok, Reels, and Shorts.",
    slug:
      "/blog/how-creators-increase-watch-time",
    image:
      "/og/watch-time.jpg",
    badge:
      "Watch Time",
    category: "shorts",
    categoryLabel:
      "Watch Time",
    tags: [
      "watch-time",
      "shorts",
      "retention"
    ],
    keywords: [
      "watch time",
      "Shorts",
      "retention"
    ],
    featured: false,
    publishedTime: "2026-07-04",
    updatedTime: "2026-07-04",
    readTime: "9 min read"
  },

  {
    id:
      "best-ai-tools-for-content-creators",
    title:
      "Best AI Tools for Content Creators",
    description:
      "Discover the best AI tools creators use for hooks, captions, scripts, retention, watch time, and faster content workflows.",
    slug:
      "/blog/best-ai-tools-for-content-creators",
    image:
      "/og/ai-tools-for-creators.jpg",
    badge:
      "AI Creator Tools",
    category: "ai-tools",
    categoryLabel:
      "AI Creator Tools",
    tags: [
      "ai-tools",
      "creator-tools",
      "workflow"
    ],
    keywords: [
      "AI tools",
      "creator tools",
      "workflow"
    ],
    featured: true,
    publishedTime: "2026-07-04",
    updatedTime: "2026-07-04",
    readTime: "10 min read"
  }
];

export default blogPosts;